import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarFile, F0Button, F0TagRaw } from '@factorialco/f0-react'
import { Download as DownloadIcon } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { download } from './download'
import { ATTACHMENT_ROOT_STYLE, BORDER, BORDER_RADIUS } from './styles'

export interface FileLike {
  name: string
  type?: string
  signed?: boolean
  url: string
}

interface AttachmentsProps {
  files: FileLike[]
}

const Attachments = ({ files }: AttachmentsProps) => {
  return (
    <Box border={BORDER} borderRadius={BORDER_RADIUS} cursor="pointer">
      {files.map((file) => (
        <Box
          key={file.name}
          flexDirection="row"
          alignItems="center"
          style={ATTACHMENT_ROOT_STYLE}
          onClick={() => window.open(file.url, '_blank')}
        >
          <F0AvatarFile
            file={{
              name: file.name,
              type: file.type ?? '',
            }}
            size="md"
          />
          <Box flexGrow>
            <Text size="200" color="neutralForegroundPrimary">
              {file.name}
            </Text>
          </Box>
          {file.signed && (
            <F0TagRaw text={i18n.t('expenses_v2.forms.fields.signed_document.signed')} />
          )}
          <F0Button
            icon={DownloadIcon}
            label={i18n.t('common.download')}
            variant="outline"
            onClick={() => download({ fullPath: file.url, filename: file.name })}
            hideLabel
          />
        </Box>
      ))}
    </Box>
  )
}

export default Attachments
